import React from 'react'
import './styles.scss'
import { Waypoint } from 'react-waypoint'

const isMobile = window.innerWidth < 600

export class Highlighter extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      overlayed: false
    }
  }

  componentDidMount() {}

  render() {
    return (
      <div
        className={
          this.state.overlayed
            ? 'highlight-wrapper overlayed'
            : 'highlight-wrapper'
        }
      >
        <img className='ui image fluid overlay' src={this.props.overlayImage} />
        <img className='ui image fluid photo' src={this.props.baseImage} />
        <Waypoint
          onEnter={event => {
            this.setState({ overlayed: true })
          }}
          onLeave={event => {
            this.setState({ overlayed: false })
          }}
        />
      </div>
    )
  }
}
